import { Power1, TweenLite } from 'gsap'

const selectSVG = (id: string) => {
  const el = document.getElementById(id)
  svg = new DecoSVGElement(<HTMLElement>el)
}

const createSVG = (type: any) => {
  const el = document.createElementNS('http://www.w3.org/2000/svg', type)
  return new DecoSVGElement(el)
}

class DecoSVGElement {
  element: HTMLElement

  constructor(element: HTMLElement) {
    this.element = element
  }

  set(attributeName: string, value: any) {
    this.element.setAttribute(attributeName, value)
  }

  style(property: string, value: any) {
    //@ts-ignore
    this.element.style[property] = value
  }
}

let localDecorSize = 30
let localDuration = 1
let svg: any = ''
// svgSize
let width = window.innerWidth
let height = window.innerHeight
const color = {
  main: '#FBDB4A',
  shades: ['#FAE073', '#FCE790', '#FADD65', '#E4C650']
}
let localOnComplete: any = ''

const resizeSvg = ({
  decorSize,
  svgSize
}: {
  decorSize?: number
  svgSize?: { width: number; height: number }
}) => {
  if (decorSize) {
    localDecorSize = decorSize
  }
  if (svgSize) {
    width = svgSize.width
    height = svgSize.height
  }
  svg.set('height', height)
  svg.set('width', width)
  svg.set('viewBox', `0 0 ${width} ${height}`)
}

const addDecor = (el: Element, color: any, decorPos?: {x?: number, y?: number}) => {
  setTimeout(() => {
    var rect = el.getBoundingClientRect()
    const x0 = decorPos && decorPos.x ? decorPos.x: rect.left + rect.width / 2
    const y0 = decorPos && decorPos.y ? decorPos.y: rect.top + rect.height / 2
    const shade = color.shades[Math.floor(Math.random() * 4)]
    for (var i = 0; i < 8; i++) addTri(x0, y0, shade)
    for (var i = 0; i < 8; i++) addCirc(x0, y0)

    
    setTimeout(() => {
      localOnComplete && localOnComplete();
    }, localDuration * 1000 / 3);
  }, 150)
}

const addTri = (x0: number, y0: number, shade: string) => {
  const tri = createSVG('polygon')
  const a = Math.random()
  const a2 = a + (-0.2 + Math.random() * 0.4)
  const r = localDecorSize * 0.52
  const r2 = r + localDecorSize * Math.random() * 0.2
  const x = x0 + r * Math.cos(2 * Math.PI * a)
  const y = y0 + r * Math.sin(2 * Math.PI * a)
  const x2 = x0 + r2 * Math.cos(2 * Math.PI * a2)
  const y2 = y0 + r2 * Math.sin(2 * Math.PI * a2)
  const triSize = localDecorSize * 0.1
  const scale = 0.3 + Math.random() * 0.7
  const offset = triSize * scale
  tri.set('points', `0,0 ${triSize * 2},0 ${triSize},${triSize * 2}`)
  tri.style('fill', shade)
  svg.element.appendChild(tri.element)
  TweenLite.fromTo(
    tri.element,
    localDuration,
    {
      rotation: Math.random() * 360,
      scale: scale,
      x: x - offset,
      y: y - offset,
      opacity: 1
    },
    {
      x: x2 - offset,
      y: y2 - offset,
      opacity: 0,
      ease: Power1.easeInOut,
      onComplete: () => {
        svg.element.removeChild(tri.element)
      }
    }
  )
}

const addCirc = (x0: number, y0: number) => {
  const circ = createSVG('circle')
  const a = Math.random()
  const r = localDecorSize * 0.52
  const r2 = r + localDecorSize
  const x = x0 + r * Math.cos(2 * Math.PI * a)
  const y = y0 + r * Math.sin(2 * Math.PI * a)
  const x2 = x0 + r2 * Math.cos(2 * Math.PI * a)
  const y2 = y0 + r2 * Math.sin(2 * Math.PI * a)
  const circSize = localDecorSize * 0.05 * Math.random()
  circ.set('r', circSize)
  circ.style('fill', '#eee')
  svg.element.appendChild(circ.element)
  TweenLite.fromTo(
    circ.element,
    localDuration,
    { x: x - circSize, y: y - circSize, opacity: 1 },
    {
      x: x2 - circSize,
      y: y2 - circSize,
      opacity: 0,
      ease: Power1.easeInOut,
      onComplete: () => {
        svg.element.removeChild(circ.element)
      }
    }
  )
}

const addDecor2El = ({
  decorSize,
  decorPos,
  svgSize,
  selector,
  duration,
  onComplete
}: {
  decorSize?: number
  decorPos?: { x?: number, y?: number}
  svgSize?: { width: number; height: number }
  selector?: Array<string> | string,
  duration?: number,
  onComplete?: Function
}) => {
  if (!selector || !selector.length) {
    return
  }

  if (typeof duration === 'number') {
    localDuration = duration
  }

  if (onComplete) {
    localOnComplete = onComplete
  }

  !svg && selectSVG('svg')
  resizeSvg({ decorSize, svgSize })
  const selectors = Array.isArray(selector) ? selector : [selector]
  const items = document.querySelectorAll(selectors[0])
  Array.from(items).forEach((item, index) => {
    setTimeout(() => {
      const icon =
        selectors.length > 1 ? item.querySelector(selectors[1]) : item
      addDecor(<Element>icon, color, decorPos)
    }, 1000 * (index + 1))
  })
}

export default addDecor2El
export {selectSVG, resizeSvg}
